import React from 'react';
import PropTypes from 'prop-types';
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const InspectionQtyTrends = (props) => {
	return (
		<ResponsiveContainer height={props.height}>
			<BarChart data={props.data} margin={{top: 20, bottom: 20}}>
				<CartesianGrid strokeDasharray="3 3"/>
				<XAxis dataKey="name"/>
				<YAxis/>
				<Tooltip/>
				<Bar dataKey="value" label={{ position: 'top' }} maxBarSize={60}/>
			</BarChart>
		</ResponsiveContainer>
	)
};

InspectionQtyTrends.defaultProps = {
	height: 140
};

InspectionQtyTrends.propTypes = {
	data: PropTypes.array.isRequired,
	height: PropTypes.number
};

export default InspectionQtyTrends;
